import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import { Grid, Typography, TextField, Button } from '@material-ui/core';
import Cookies, { set } from 'js-cookie';

class ForgotPassword extends Component {
    constructor(props){
        super(props);

        const search = this.props.location.search;

        this.state = {
            idSekolah : new URLSearchParams(search).get("idSekolah"),
            token : new URLSearchParams(search).get("token"),
            email: null,
            password1: null,
            password2: null
        }
    }

    componentDidMount(){
    }

    handleOnChange = async (e) =>{
        const {id, value} = e.target;

        this.setState({
            isNotMatch: false,
            [id]: value
        });
    }

    render() {
        const {email, password1, password2, isPassword1, isPassword2, isNotMatch} = this.state;
        return (
            <Container style={{placeContent: "center", marginTop: "30px"}}>
                <form onSubmit={this.handleSubmit} >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5" color="textPrimary">Reset Ulang Password</Typography>
                        </Grid>

                        <Grid item xs={12} md={4} xl={4}>
                            <TextField
                            id="usernameAdmin"
                            label="Username Yang terdaftar"
                            variant="outlined"
                            size="small"
                            value={email}
                            onChange={this.handleOnChange} 
                            fullWidth      
                            required
                            />
                        </Grid>

                        <Grid item xs={12} md={4} xl={4}>
                            <TextField
                                id="password1"
                                size="small"
                                variant="outlined"
                                label="Password Baru"
                                type={!isPassword1 ? "password" : "text"}
                                value={!password1 ? '': password1}
                                onChange={this.handleOnChange}
                                required
                                InputProps={{
                                    endAdornment:
                                        <IconButton
                                            size="small"
                                            onClick={() => this.setState({isPassword1 : !isPassword1})}
                                            edge="end"
                                        >
                                        {   isPassword1 ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                }}
                            />
                        </Grid>
                        
                        <Grid item xs={12} md={4} xl={4}>
                            <TextField
                                id="password2"
                                size="small"
                                variant="outlined"
                                label={!isNotMatch ? "Ulangi Password" : "Password 1 & 2 tidak sesuai"}
                                type={!isPassword2 ? "password" : "text"}
                                value={!password2 ? '': password2}
                                onChange={this.handleOnChange}
                                required
                                error={isNotMatch}
                                InputProps={{
                                    endAdornment:
                                        <IconButton
                                            size="small"
                                            onClick={() => this.setState({isPassword2 : !isPassword2})}
                                            edge="end"
                                        >
                                        {   isPassword2 ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} style={{textAlign: 'center'}}>
                            <Button type="submit" variant="outlined" color="primary"  style={{textTransform: 'none'}}>
                            Simpan
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        );
    }

    handleSubmit = async (e) =>{
        e.preventDefault();

        const {usernameAdmin, password1, password2, idSekolah, token} = this.state;

        if(password1 != password2){
            this.setState({isNotMatch : true});
            return;
        }else{
            const response = await accountManagement.put(CONFIG.ACCOUNT_MANAGEMENT_VERIFICATION_ACCOUNT 
                    +'idSekolah='+ idSekolah
                    +'&token='+ token 
                ,{
                    'usernameAdmin': usernameAdmin,
                    'password': password1
                }).catch(function(error){
                    console.info('Error Forgot', error)
            })
        }
        console.log(this.state)
    }
}

export default ForgotPassword;